import http from "../../http-common";

const getClient = async (query) => {
  return await http
    .get("/support", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getParty = async (id, identify) => {
  return await http
    .get(`/support/party/${id}`, { params: { query: identify } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getTicket = async (id, identify) => {
  return await http
    .get(`/support/ticket/${id}`, { params: identify })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const transferTicket = async (id, data) => {
  return await http
    .post(`/support/ticket/${id}/transfer`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const createToken = async (data) => {
  return await http
    .post(`/support/user-token`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

export default {
  getClient,
  getParty,
  getTicket,
  transferTicket,
  createToken,
};
